/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';
import Icon from '@legacy-vfuk/core-icon';
import Heading from '@legacy-vfuk/core-heading';
import Spacing from '@legacy-vfuk/core-spacing';
import { HeaderContentProps } from '../Header/Header';
import { RichTextProps } from '../RichText/RichText';
import RichText from '../RichText';
import IconContainer from './styes/FeatureItems.styles'

const FeatureItemsWrapper = styled.div`
  padding: 20px;
`;

const FeatureHeaderWrapper = styled.div`
  padding: 20px 0;
`;

type ElementIconLinkProps = {
  kind?: 'icon';
  id: string;
  url?: string;
  label?: string;
  name?: string;
  iconRef: string;
  color?: string;
  iconSize: 1 | 2 | 3 | 4 | 5;
  appearance?: 'primary' | 'secondary';
  inverse?: boolean;
  size: 'small' | 'medium' | 'large' | 'extra-large';
  __typename?: string;
};

type FeatureItemContentProps =
  | ElementIconLinkProps
  | RichTextProps
  | HeaderContentProps;

export type FeatureItemProps = {
  id?: string;
  items: {
    id: string;
    content: FeatureItemContentProps[];
    isCentred: boolean;
    name: string;
    __typename: string;
  };
};

const FeatureItems = ({ items }: FeatureItemProps) => {
  const featureProps = items?.content?.map((item: any) => {
    switch (item.__typename) {
      case 'ContentfulSectionElementHeader': {
        const { level, justify, headerText } = item;
        return (
          <FeatureHeaderWrapper key={item.id}>
            <Heading text={headerText} level={level} justify={justify} />
          </FeatureHeaderWrapper>
        );
      }

      case 'ContentfulSectionElementIconLink': {
        const { iconRef, color, iconSize, appearance, inverse } = item;
        return (
          <div key={item.id} style={{ color: color, textAlign: 'center' }}>
            <Spacing spacingLevel={{ bottom: 6 }}>
              <IconContainer>
              <Icon
                name={iconRef}
                size={iconSize}
                appearance={appearance || "primary"}
                inverse={inverse}
              />
              </IconContainer>
            </Spacing>
          </div>
        );
      }

      case 'ContentfulSectionElementRichText': {
        return (
          <RichText
            key={item.id}
            text={item.text}
            color={item.color}
            textAlign={item.textAlign}
          />
        );
      }
      default:
        return null;
    }
  });

  return (
    <FeatureItemsWrapper>{featureProps}</FeatureItemsWrapper>
  );
};

export default FeatureItems;
